import { Grid, Text } from '@approvalmax/ui/src/components';
import { FC, memo, useCallback } from 'react';
import { amplitudeService } from 'services/amplitude';
import { getPath, Path, WorkflowsGettingStarted } from 'urlBuilder';

import { CollapseSection } from '../CollapseSection/CollapseSection';
import { VideoPopup } from '../VideoPopup/VideoPopup';
import { messages } from './WorkflowSetup.messages';
import { WorkflowSetupProps } from './WorkflowSetup.types';

export const WorkflowSetup: FC<WorkflowSetupProps> = memo((props) => {
    const { number, collapsed, complete, companyId, imgSrc, videoSrc, profileId, isStandalone } = props;

    const handleVideoOpen = useCallback(() => {
        amplitudeService.sendData('getting started: clicked on matrix video', {
            user_id: profileId,
            org_id: companyId,
            type: isStandalone ? 'GL' : 'Standalone',
        });
    }, [companyId, isStandalone, profileId]);

    const handleButtonClick = useCallback(() => {
        amplitudeService.sendData('getting started: clicked on set up workflow', {
            user_id: profileId,
            org_id: companyId,
            type: isStandalone ? 'GL' : 'Standalone',
        });
    }, [companyId, isStandalone, profileId]);

    return (
        <CollapseSection
            collapsed={collapsed}
            complete={complete}
            number={number}
            title={messages.title}
            buttonText={messages.buttonText}
            buttonLink={getPath(Path.companyWorkflows, companyId, {
                gettingStarted: isStandalone ? WorkflowsGettingStarted.tour : WorkflowsGettingStarted.wizard,
            })}
            onButtonClick={handleButtonClick}
        >
            <Grid gridTemplateColumns='1fr auto' gap={12}>
                <Text font='body'>
                    {isStandalone
                        ? messages.descriptionStandalone({ br: <br /> })
                        : messages.description({ br: <br /> })}
                </Text>

                <VideoPopup title={messages.title} imgSrc={imgSrc} videoSrc={videoSrc} onOpen={handleVideoOpen} />
            </Grid>
        </CollapseSection>
    );
});

WorkflowSetup.displayName = 'WorkflowSetup';
